import { Theme } from '@mui/material'
import { SxProps } from '@mui/system'

type ClassName =
    | 'boxCenter'
    | 'typeInputButton'
    | 'valueInputButton'
    | 'paymentInputButton'
    | 'splitEvenlyButton'
    | 'splitEvenlyButtonContainer'
    | 'dialogContainer'
    | 'topleftPanel'
    | 'leftPanelContainer'
    | 'mainPanelContainer'
    | 'bottomleftPanel'
    | 'background'
    | 'backgroundTender'
    | 'confirmPanel'
    | 'currencyBannerBG'
    | 'detailTextFont'
    | 'listDetailContainer'
    | 'confirmButton'
    | 'detailTextFontMobile'

const paymentDialogStyle: Record<ClassName, SxProps<Theme>> = {
    //input form
    boxCenter: {
        justifyItems: 'center',
        display: 'grid',
    },
    typeInputButton: {
        display: 'grid',
        width: 180,
        justifyContent: 'start',
    },
    valueInputButton: {
        width: 120,
        justifyContent: 'end',
        color: 'text.primary',
    },
    paymentInputButton: {
        color: 'text.primary',
        justifyContent: 'space-between',
    },
    // split payment
    splitEvenlyButtonContainer: {
        position: 'relative',
    },
    splitEvenlyButton: {
        height: 60,
        position: 'absolute',
        bottom: '14px',
        right: '5px',
    },
    dialogContainer: {
        padding: '5px',
    },
    topleftPanel: {
        height: '100%',
    },
    //Single payment
    leftPanelContainer: {
        position: 'relative',
        height: '75svh',
        overflow: 'auto',
    },
    mainPanelContainer: {
        position: 'relative',
        height: '75svh',
        // height: '100%',
        overflow: 'auto',
    },
    bottomleftPanel: {
        height: 130,
        position: 'absolute',
        bottom: '5px',
        left: '10px',
        right: '5px',
    },
    //Payment detail
    background: {
        backgroundColor: 'background.default',
        height: '100%',
        position: 'relative',
        flexWrap: 'nowrap',
    },
    backgroundTender: {
        height: '80%',
        backgroundColor: 'topside.paper',
    },
    confirmPanel: {
        bottom: 0,
        left: 0,
        right: 0,
    },
    currencyBannerBG: {
        backgroundColor: 'primary.main',
        // margin: '10px',
        height: 70,
        borderRadius: '4px',
        // padding: '10px',
        color: 'white',
        textTransform: 'uppercase',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    detailTextFont: {
        fontSize: 20,
    },
    detailTextFontMobile: {
        fontSize: 16,
    },
    listDetailContainer: {
        backgroundColor: 'topside.paper',
    },
    confirmButton: {
        height: 60,
    },
}

export default paymentDialogStyle
